module.exports = __webpack_public_path__ + "img/voice-square.c54f3d43.svg";